export const handleImageLoad = (index,setImgLoaded) => {
    setImgLoaded((prev) => ({ ...prev, [index]: true }));
  };